import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pluginPlatformApi, type PluginRecord } from '../../api/pluginplatform';

export function PluginManagerPage() {
  const [plugins, setPlugins] = useState<PluginRecord[]>([]);
  const [error, setError] = useState('');

  function load() {
    void pluginPlatformApi.listPlugins().then((r) => setPlugins(r.plugins)).catch((e) => setError(String(e)));
  }

  useEffect(() => { load(); }, []);

  async function disable(id: string) {
    await pluginPlatformApi.disable(id);
    load();
  }

  async function uninstall(id: string) {
    await pluginPlatformApi.uninstall(id);
    load();
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/plugins" className="text-sm text-blue-600 hover:underline">← Plugin Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Plugin Manager</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-3">
        {plugins.map((p) => (
          <div key={p.id} className="flex items-center justify-between rounded-xl border p-4 dark:border-slate-700">
            <div>
              <p className="font-medium">{p.name}</p>
              <p className="text-sm text-slate-500">{p.plugin_id} · v{p.version} · {p.state}</p>
            </div>
            <div className="flex gap-2">
              <button type="button" onClick={() => void disable(p.plugin_id)} className="rounded border px-3 py-1 text-sm">Disable</button>
              <button type="button" onClick={() => void uninstall(p.plugin_id)} className="rounded border px-3 py-1 text-sm text-red-600">Uninstall</button>
            </div>
          </div>
        ))}
        {plugins.length === 0 && <p className="text-sm text-slate-500">No plugins installed. Browse the marketplace to install.</p>}
      </div>
    </div>
  );
}
